import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

interface ClienteImportado {
  nome: string;
  cnpj: string;
  cep: string;
  endereco: string;
  bairro: string;
  cidade: string;
  uf: string;
  email: string;
  telefone: string;
  saldo: string;
  senhaOriginal: string;
}

export function useImportarCliente() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const importarCliente = async () => {
    try {
      setIsLoading(true);
      
      // Ler dados da área de transferência
      const textoClipboard = await navigator.clipboard.readText();
      
      // Tentar converter para objeto JSON
      let clienteImportado: ClienteImportado;
      try {
        clienteImportado = JSON.parse(textoClipboard);
      } catch (error) {
        toast.error('Formato inválido na área de transferência. Certifique-se de copiar um JSON válido.');
        return;
      }
      
      // Validar se o objeto tem a estrutura esperada
      if (!clienteImportado.nome || !clienteImportado.email) {
        toast.error('Dados incompletos na área de transferência.');
        return;
      }
      
      // Formatar os dados para o formato esperado pelo formulário de usuário
      // Converter o saldo para número, removendo qualquer caractere não numérico
      const saldoString = clienteImportado.saldo.replace(/[^\d]/g, '');
      const saldoConvertido = parseInt(saldoString, 10);

      const dadosFormatados = {
        nome: clienteImportado.nome.trim(),
        email: clienteImportado.email.trim(),
        tipo: 'cliente', // Definindo como cliente
        documento: clienteImportado.cnpj,
        cep: clienteImportado.cep,
        endereco: clienteImportado.endereco,
        bairro: clienteImportado.bairro,
        cidade: clienteImportado.cidade,
        uf: clienteImportado.uf,
        telefone: clienteImportado.telefone,
        saldo: saldoConvertido,
        senha: clienteImportado.senhaOriginal || '123456', // Garantindo que sempre tenha uma senha
        ativo: true
      };
      
      // Navegar para a tela de criação de usuário com os dados pré-preenchidos
      // Usando replace para evitar problemas com a navegação
      navigate('/usuarios/novo', { 
        state: { dadosImportados: dadosFormatados },
        replace: true 
      });
      
      toast.success('Cliente importado com sucesso!');
    } catch (error) {
      console.error('Erro ao importar cliente:', error);
      toast.error('Erro ao importar cliente. Verifique o console para mais detalhes.');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    importarCliente,
    isLoading
  };
} 